/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import State from './State';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

export enum StateMode
{
    Enter,
    Exit
}

/** A streamlined state machine utilized by [[Reel]]s. */
@cc._decorator.ccclass
export default class StateMachine extends cc.Component
{
    /** The [[State]]s, in order, which comprise this [[StateMachine]]. */
    @property([State])
    private states: State[] = [];

    /** @hidden */
    private currentState: State = null;

    /**
     * Sets the active state in the state machine.
     * @param stateName The name of the state to switch to.
     */
    public SetState(stateName: string): void
    {
        if (this.currentState != null)
        {
            this.currentState.Exit();
        }
        let newState: State = this.getStateByName(stateName);
        this.currentState = newState;
        this.currentState.Enter();
    }

    /**
     * Helper to retrieve a [[State]] object from the collection by name.
     * @param stateName The string name of the state to retrieve.
     * @returns The requested State, or null if not found.
     * @hidden
     */
    private getStateByName(stateName: string): State
    {
        return this.states.find((x) => x.node.name === stateName);
    }

    /**
     * Returns the string name of the currently active [[State]].
     * @returns The string name of the active [[State]].
     */
    public GetCurrentStateName(): string
    {
        return this.currentState.node.name;
    }
}
